import { Route, Routes } from 'react-router-dom';
import React, { Suspense } from "react";
import Units from '../../../views/Direccion/Unidades/Units';
import MaestroDeZonas from '../../../views/Direccion/MaestroDeZonas/MaestroDeZonas';

const Direccion = () => {
    return (
        <Routes>
            <Route exact path="/direccion/unidades"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <Units></Units>
                       </Suspense>
                   }>
            </Route>
            <Route exact path="/direccion/maestro-zonas"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <MaestroDeZonas></MaestroDeZonas>
                       </Suspense>
                   }>
            </Route>
        </Routes>
    )

}

export default Direccion
